import React from 'react'
import useAppContext from '../../hook/useAppContext'
import User from '../user/User'
import './banner.css'

const Banner = () => {

      const {user, data} = useAppContext()
      const {personal, banners} = user 

      const banner_img = banners.code ? data.banner.image : banners[0].url
      const banner_txt = banners.code ? data.banner.title : banners[0].title

      return (
            <div className="banner_group">
                  <div className="banner_content">
                        <div className="banner_content__img flex">
                              <img src={banner_img} alt={banner_txt} />
                        </div>
                        <button className="btn_toggle__menu">
                              <span></span>
                              <span></span>
                              <span></span>
                        </button>
                  </div>
                  <User info={personal} data={data} />
            </div>
      )
}

export default Banner
